import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as analytics from '../services/analytics';

interface UseAnalyticsProps {
  trackPageViews?: boolean;
}

export const useAnalytics = ({ trackPageViews = true }: UseAnalyticsProps = {}) => {
  const location = useLocation();

  // Track page views automatically
  useEffect(() => {
    if (trackPageViews) {
      analytics.trackPageView(location.pathname + location.search);
    }
  }, [location, trackPageViews]);

  return {
    trackChatbarPersonalization: analytics.trackChatbarPersonalization,
    trackPlanUploadClick: analytics.trackPlanUploadClick,
    trackPlanUploadSuccess: analytics.trackPlanUploadSuccess,
    trackProfileMenuClick: analytics.trackProfileMenuClick,
    trackAccountSettingsClose: analytics.trackAccountSettingsClose,
    trackAccountSettingsSave: analytics.trackAccountSettingsSave,
    trackAccountSettingsLogout: analytics.trackAccountSettingsLogout,
    trackConfirmationAlertClick: analytics.trackConfirmationAlertClick,
    trackPIIFormUserSelector: analytics.trackPIIFormUserSelector,
    trackPIIFormConfirm: analytics.trackPIIFormConfirm,
    trackPIIFormClose: analytics.trackPIIFormClose
  };
};

export default useAnalytics; 